import React from "react";
import { Flex, Text, Grid, GridItem, Button } from "@chakra-ui/react";
import { FaMountain } from "react-icons/fa";
import { motion } from "framer-motion";

const MotionButton = motion(Button);

export const ViatorSection = ({ show, onOpen }) => {
  if (!show) return null;
  
  const lively = "linear-gradient(270deg,#8B5CF6,#7C3AED,#6366F1,#A855F7,#8B5CF6)";

  return (
    <Flex pt={4} pb={4} flexDirection="column">
      <Text px={{ base: 3, md: 0 }} fontSize={{ base: "12px", md: "18px" }} fontWeight={800} pb={4}>
        Viator Experiences
      </Text>
      <Grid templateColumns="1fr" mx={{ base: 4, md: 0 }} maxW={{ md: "360px" }}>
        <GridItem>
          <MotionButton
            onClick={onOpen}
            color="white"
            h="42px"
            w="full"
            variant="solid"
            borderRadius="10px"
            fontSize="14px"
            leftIcon={<FaMountain />}
            style={{
              backgroundSize: "400% 400%",
              position: "relative",
              overflow: "hidden",
            }}
            initial={{ backgroundImage: lively, backgroundPosition: "0% 50%" }}
            animate={{ backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"] }}
            transition={{
              backgroundPosition: {
                duration: 3,
                ease: "easeInOut",
                repeat: Infinity,
              },
            }}
          >
            Explore Experiences
          </MotionButton>
        </GridItem>
      </Grid>
    </Flex>
  );
}; 